import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/logo2.png';
import Button from '../reusable/Button/Button';

import { useDispatch, useSelector } from 'react-redux';
import addUser from '../../assets/addUser2.svg';
import addUserActive from '../../assets/addUserActive2.svg';
import arrowUp from '../../assets/arrowUp.svg';
import budget from '../../assets/budget2.svg';
import budgetActive from '../../assets/budgetActive2.svg';
import cloud from '../../assets/cloud2.svg';
import cloudActive from '../../assets/cloudActive2.svg';
import dashboard from '../../assets/dashboard2.svg';
import dashboardActive from '../../assets/dashboardActive2.svg';
import settings from '../../assets/settings2.svg';
import settingsActive from '../../assets/settingsActive2.svg';
import signOut from '../../assets/signOut.svg';
import team from '../../assets/team2.svg';
import teamActive from '../../assets/teamActive2.svg';
import WarningIcon from '../../assets/warning-icon.svg';
import api from '../../config/api';
import {
  CREATE_BUDGET_PATH,
  CREATE_CLIENT_PATH,
  CREATE_DATA_SOURCE_PATH,
  CREATE_TEAM_PATH,
  DASHBOARD_PATH,
  SETTING_ACCOUNT_PATH,
  SETTING_AUTOMATED_RULES_PATH,
  SETTING_USAGE_BILLING_PATH,
  SETTING_USER_PATH,
} from '../../contants';
import { STATUS } from '../../contants/datasource';
import { PERMISSIONS } from '../../contants/permissions';
import { setRuleManagerState } from '../../features/userSettings/userSettingsSlice';
import { checkIfPaymentIsValid, isReadOnlyOrPaymentValid } from '../../utils';
import css from './Sidebar.module.css';

const Sidebar = () => {
  const [isSettings, setIsSettings] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const { currentUser } = useSelector(state => state.me);
  const { dataSource } = useSelector(state => state.dataSource);

  const dispatch = useDispatch();

  const isWarningTabDataSource = dataSource?.find(
    dataSource => dataSource.status !== STATUS.ACTIVE,
  );
  const { notifications, company = null } = currentUser || {};
  const permissionOfCurrUser = currentUser?.permission_level?.name;
  const isReadOnly = permissionOfCurrUser === PERMISSIONS.READ_ONLY;
  const isNotAdmin =
    permissionOfCurrUser === PERMISSIONS.READ_ONLY ||
    permissionOfCurrUser === PERMISSIONS.STANDARD;

  const hasSubscriptionIssue =
    !checkIfPaymentIsValid(notifications) || !company;
  const hasSubscriptionOrReadOnlyProblem =
    !isReadOnlyOrPaymentValid(notifications, isReadOnly) || !company;

  const canAccessAutomated = !isReadOnly && company;
  const canAccessAccount = !isNotAdmin && company;
  const canAccessUsage = !isNotAdmin && company;

  useEffect(() => {
    location.pathname.includes('/settings')
      ? setIsSettings(true)
      : setIsSettings(false);
  }, [location.pathname]);

  const handleSignOut = () => {
    api
      .LOG_OUT()
      .then(res => {
        if (res.status === 'OK') {
          localStorage.removeItem('ACCESS_TOKEN');
          localStorage.removeItem('REFRESH_TOKEN');
          navigate('/login', { replace: true });
        }
      })
      .catch(() => {
        navigate('/login', { replace: true });
      });
  };

  const handleSettings = () => setIsSettings(!isSettings);

  const handleClickAutomatedRules = () => {
    const { pathname } = location;
    if (pathname === SETTING_AUTOMATED_RULES_PATH)
      dispatch(setRuleManagerState(false));
  };

  const hasSubscriptionIssueClass = ({ isActive }) =>
    hasSubscriptionIssue ? css.disable : isActive ? css.active : css.navLink;

  const hasSubscriptionOrReadOnlyProblemClass = ({ isActive }) =>
    hasSubscriptionOrReadOnlyProblem
      ? css.disable
      : isActive
      ? css.active
      : css.navLink;

  return (
    <aside className={css.aside}>
      <div>
        <img className={css.logo} alt="Logo" src={logo} />
        <nav className={css.nav}>
          <NavLink
            className={hasSubscriptionIssueClass}
            to={hasSubscriptionIssue ? '#' : DASHBOARD_PATH}
          >
            <div className={css.imgContainer}>
              <img
                alt="dashboard"
                src={
                  location.pathname.includes(DASHBOARD_PATH)
                    ? dashboardActive
                    : dashboard
                }
              />
            </div>
            Dashboard
          </NavLink>
          <NavLink
            disabled
            className={hasSubscriptionOrReadOnlyProblemClass}
            to={hasSubscriptionOrReadOnlyProblem ? '#' : CREATE_CLIENT_PATH}
          >
            <div className={css.imgContainer}>
              <img
                alt="create client"
                src={
                  location.pathname.includes(CREATE_CLIENT_PATH)
                    ? addUserActive
                    : addUser
                }
              />
            </div>
            Create Client
          </NavLink>
          <NavLink
            className={props =>
              hasSubscriptionOrReadOnlyProblemClass({
                isActive:
                  props.isActive ||
                  location.pathname.includes(CREATE_BUDGET_PATH),
              })
            }
            to={
              hasSubscriptionOrReadOnlyProblem ? '#' : `${CREATE_BUDGET_PATH}/client`
            }
          >
            <div className={css.imgContainer}>
              <img
                alt="create budget"
                src={
                  location.pathname.includes(CREATE_BUDGET_PATH)
                    ? budgetActive
                    : budget
                }
              />
            </div>
            Create Budget
          </NavLink>
          <NavLink
            className={hasSubscriptionOrReadOnlyProblemClass}
            to={hasSubscriptionOrReadOnlyProblem ? '#' : CREATE_DATA_SOURCE_PATH}
          >
            <div className={css.imgContainer}>
              <img
                alt="data sources"
                src={
                  location.pathname.includes(CREATE_DATA_SOURCE_PATH)
                    ? cloudActive
                    : cloud
                }
              />
            </div>
            Data Sources
            {location.pathname !== CREATE_DATA_SOURCE_PATH &&
              isWarningTabDataSource && (
                <img
                  className={css.warningTabDataSource}
                  src={WarningIcon}
                  alt=""
                />
              )}
          </NavLink>
          <NavLink
            className={hasSubscriptionOrReadOnlyProblemClass}
            to={hasSubscriptionOrReadOnlyProblem ? '#' : CREATE_TEAM_PATH}
          >
            <div className={css.imgContainer}>
              <img
                alt="team"
                src={location.pathname.includes(CREATE_TEAM_PATH) ? teamActive : team}
              />
            </div>
            Team
          </NavLink>
          <div
            className={
              location.pathname.includes('/settings') || isSettings
                ? css.active
                : css.navLink
            }
            onClick={handleSettings}
          >
            <div className={css.imgContainer}>
              <img
                alt="settings"
                src={
                  location.pathname.includes('/settings') || isSettings
                    ? settingsActive
                    : settings
                }
              />
            </div>
            Settings
            {isSettings && (
              <div className={`${css.imgContainer} ${css.right}`}>
                <img alt="arrow up" src={arrowUp} />
              </div>
            )}
          </div>
          {isSettings && (
            <ul>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    !canAccessAutomated
                      ? css.disableSetting
                      : isActive
                      ? css.activeSetting
                      : css.navLinkSetting
                  }
                  to={!canAccessAutomated ? '#' : SETTING_AUTOMATED_RULES_PATH}
                  onClick={handleClickAutomatedRules}
                >
                  Automated Rules
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? css.activeSetting : css.navLinkSetting
                  }
                  to={SETTING_USER_PATH}
                >
                  User Settings
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    !canAccessAccount
                      ? css.disableSetting
                      : isActive
                      ? css.activeSetting
                      : css.navLinkSetting
                  }
                  to={!canAccessAccount ? '#' : SETTING_ACCOUNT_PATH}
                >
                  Account Settings
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    !canAccessUsage
                      ? css.disableSetting
                      : isActive
                      ? css.activeSetting
                      : css.navLinkSetting
                  }
                  to={!canAccessUsage ? '#' : SETTING_USAGE_BILLING_PATH}
                >
                  Usage & Billing
                </NavLink>
              </li>
            </ul>
          )}
        </nav>
      </div>
      <Button styled="signOut" onClick={handleSignOut}>
        <div className={css.signOutWrapper}>
          <img className={css.signOutImg} alt="sign out" src={signOut} />
          <span className={css.signOutText}>Sign out</span>
        </div>
      </Button>
    </aside>
  );
};

export default Sidebar;
